import {React, useState, useEffect} from "react";
import { PDFDownloadLink} from '@react-pdf/renderer';
import DocumentComponent from './PDFComponent';


import CreatorPdfDesktop from "./createPdf/CreatorPdfDesktop";


const PDFButton = (props) => {


    const [code, setCode] = useState('');
      
    useEffect(() => {  
        createCanvas();
    },[props.imgs])

    function createCanvas() {
        const imgArray = [];
        const objImg = props.imgs;
        for(let key in objImg) {
            if(objImg[key] !== undefined) {
                imgArray.push(objImg[key])
            }
            
        }

        
        const ctx = props.canvasRef.current.getContext("2d");
        ctx.clearRect(0,0, 800, 800);
        const filterImgArray = imgArray.filter(item => {return item !== false && item !== ''})
        drawDataURIOnCanvas(0,  props.canvasRef.current)

        function drawDataURIOnCanvas(index, canvas) {//strDataURI, canvas, i) {
            "use strict";
            var img = new Image();
            img.crossOrigin = 'anonymous'
            img.width = 0;
            img.addEventListener("load", function () {
                
                canvas.getContext("2d").drawImage(img, 0, 0, 800, 800);
                
                if(filterImgArray.length > index+1) {
                    drawDataURIOnCanvas(index+1, canvas)
                }
                else {
                    createImg()
                }
            });
            img.setAttribute("src", filterImgArray[index]);
            
        }
    }


    

    function createImg() {
        const canvas = props.canvasRef.current;
        if(window.innerWidth > 768) {
            props.setImageSrc(canvas.toDataURL("image/png", 1));
           
        }
        else {
            setCode(canvas.toDataURL("image/png", 1));
        }
    }


    return (
        <div className="pdf-creator" onClick={() => {
                createCanvas();

                if(window.innerWidth > 768) {
                    props.openModal()
                }
            }}>
            {
            window.innerWidth > 768 ? 
                <CreatorPdfDesktop/> 
            : 

                <PDFDownloadLink className='button button--share second-stage__share-button' document={code === '' && props.config === '' && props.canvasRef.current === null ? false : <DocumentComponent canvasRef={props.canvasRef} config={props.config} imgSrc={code} />} fileName="somename.pdf">
                    {({ blob, url, loading, error }) => (
                        <>
                            <svg viewBox="-27 0 512 512" xmlns="http://www.w3.org/2000/svg">
                                <path d="m452.855469 83.6875-79.277344-79.28125c-2.824219-2.820312-6.648437-4.40625-10.640625-4.40625h-295.644531c-8.308594 0-15.046875 6.738281-15.046875 15.046875v342.878906c0 8.3125 6.738281 15.046875 15.046875 15.046875 8.3125 0 15.046875-6.734375 15.046875-15.046875v-327.828125h265.546875v63.984375c0 8.292969 6.710937 15.023438 15.003906 15.050781l64.277344.195313v372.574219h-169.394531c-8.3125 0-15.046876 6.738281-15.046876 15.050781 0 8.308594 6.734376 15.046875 15.046876 15.046875h184.441406c8.3125 0 15.046875-6.738281 15.046875-15.046875v-402.625c0-3.992187-1.582031-7.820313-4.40625-10.640625zm-74.871094-4.605469v-27.707031l27.789063 27.792969zm0 0"/><path d="m38.898438 398.582031h-28.035157c-6.089843 0-10.863281 4.117188-10.863281 9.375v86.128907c0 5.601562 5.582031 9.511718 13.574219 9.511718 7.992187 0 13.570312-3.910156 13.570312-9.511718v-26.242188h10.398438c23.085937 0 36.324219-12.550781 36.324219-34.429688v-.675781c0-21.707031-12.746094-34.15625-34.96875-34.15625zm-1.355469 46.992188h-10.394531v-22.558594h10.394531c3.941406 0 9.179687 1.09375 9.179687 10.535156v1.488281c0 9.441407-5.238281 10.535157-9.179687 10.535157zm0 0"/><path d="m113.25 398.582031h-23.972656c-6.964844 0-12.21875 4.027344-12.21875 9.375v86.265625c0 5.34375 5.253906 9.375 12.21875 9.375h23.972656c23.082031 0 36.320312-12.746094 36.320312-34.972656v-35.074219c.003907-22.226562-13.238281-34.96875-36.320312-34.96875zm0 80.578125h-9.046875v-56.144531h9.046875c3.9375 0 9.175781 1.09375 9.175781 10.535156v35.074219c0 9.441406-5.238281 10.535156-9.175781 10.535156zm0 0"/><path d="m216.175781 398.582031h-46.992187c-7.082032 0-12.21875 3.996094-12.21875 9.507813v85.996094c0 5.601562 5.578125 9.511718 13.570312 9.511718 7.992188 0 13.574219-3.910156 13.574219-9.511718v-31.929688h17.441406c6.152344 0 9.371094-5.535156 9.371094-11 0-6.53125-3.941406-11.269531-9.371094-11.269531h-17.441406v-16.871094h32.066406c5.519531 0 9.375-5.078125 9.375-12.351563 0-7.113281-3.855469-12.082031-9.375-12.082031zm0 0"/>
                            </svg>
                            <span>Скачать pdf</span>
                        </>
                        
                    )}
                </PDFDownloadLink>
            }
        </div>
        
    )
}

export default PDFButton;